export const AdditionalDocumentIcon = () => (
  <svg fill="none" height="20" viewBox="0 0 16 20" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m4 14h8v2h-8zm0-4h8v2h-8zm6-10h-8c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2h12.01c1.1 0 2-.9 2-2v-12zm4 18h-12v-16h7v5h5z"
      fill="#12191F"
    />
  </svg>
);
